export default function every(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index = -1;
  for (const value of values) {
    if (!test(value, ++index, values)) {
      return false;
    }
  }
  return true;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/every.js
// module id = 412
// module chunks = 0